import { Logger } from './logger';
import { convertWebpToJpeg, isWebpFile } from './webp';

export const MAX_DOCUMENT_UPLOAD_FILE_SIZE_BYTES = 30 * 1024 * 1024;

export class DocumentUploadFileTooLargeError extends Error {}

export function isDocumentUploadFileTooLarge(file: File): boolean {
  return file.size > MAX_DOCUMENT_UPLOAD_FILE_SIZE_BYTES;
}

export async function prepareDocumentFileForUpload(file: File): Promise<File> {
  let preparedFile = file;
  try {
    if (await isWebpFile(file)) {
      preparedFile = await convertWebpToJpeg(file);
    }
  } catch (e) {
    Logger.log('Failed to convert WebP document to JPEG', (e as Error).message);
  }
  if (isDocumentUploadFileTooLarge(preparedFile)) {
    throw new DocumentUploadFileTooLargeError();
  }
  return preparedFile;
}
